import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Terms from '@/views/category/TermsOfService.vue';
import Layout from '../views/MainLayout.vue';
import Home from '../views/Home/HomeView.vue';
import Con from '../views/category/ContactUs.vue';
import PrivacyPolicy from '../views/category/PrivacyPolicy.vue';
import IOSPrivacyPolicy from '../views/category/IOSPrivacyPolicy.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    children: [{
      path: '/',
      component: Home,
      meta: { transition: '' },
    },
    {
      path: '/terms',
      component: Terms,
      meta: { transition: '' },
    },
    {
      path: '/con',
      component: Con,
    },
    {
      path: '/privacy',
      component: PrivacyPolicy,
      meta: { transition: '' },
    },
    {
      path: '/Iprivacy',
      component: IOSPrivacyPolicy,
      meta: { transition: '' },
    },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
